module.exports = __webpack_public_path__ + "static/20210910_211214-b4097f71272dcf5c22459e54a66e180c.jpg";